export default "__VITE_ASSET__x76QBcwu__"